import { db } from '@/db';
import Dexie, { Table, liveQuery } from 'dexie';

export interface IAppStates {
  id?: number;
  isServerAuthenticated: number;
  appUser: string;
}

export class AppStates implements IAppStates {
  appstates!: Dexie.Table<IAppStates, number>;
  id!: number;
  isServerAuthenticated: number;
  appUser: string;

  constructor(isServerAuthenticated: number, appUser: string, id?:number) {
      this.isServerAuthenticated = isServerAuthenticated;
      this.appUser = appUser;
      if (id) this.id = id;
  }

  static getAuthNumberLive(){
      return new Promise(result => {
          db.appstates.where("id").equals(1).toArray(function (appstates){
              if(appstates.length == 0){
                  result(0);
              }else{
                  result(appstates[0].isServerAuthenticated);
              }
          });
      });
  }

  static async getMyUserLive(){
    return new Promise<{}>(resolve => {
        db.appstates.where("id").equals(1).toArray(function (appstates){
            if(appstates.length == 0){
                resolve({});
            }else{  
                db.appusers.where("sysId").equals(appstates[0].appUser).toArray(function (vars){
                    resolve(vars[0]);
                });
                
                //return resolve(db.appusers.where("sysId").equals(appstates[0].appUser).toArray());
            }
        });
    });
}

  static getIsServerAuthenticated() :  number{
      const res = db.appstates.where("id").equals(1).toArray(function (appstates){
          if(appstates.length == 0){
              return 0;
          }else{
              return appstates[0].isServerAuthenticated;
          }
      });
      return 0;
  }

  static setIsServerAuthenticated(to: number, appUser: string){
      db.appstates.put({id: 1, isServerAuthenticated: to, appUser: appUser}).then(function (updated) {
          if (updated){
          //  console.log ("isServerAuthenticated updated to:"+to);
          }else{
          //  console.log ("Nothing was updated");
          }
        });
      //console.log(this.getIsServerAuthenticated());
  }

}